import { z } from "zod";

// Only the two operator-editable inputs are validated here. Distributor Net
// Price and Discount Percent are ALWAYS derived (see PemserterPage) and the
// backend (svc-04) recomputes them authoritatively, so they are not form
// fields. Treat blank as "missing" so the spec's validation error fires.
const emptyToUndefined = (v: unknown) =>
  v === "" || v === null || v === undefined ? undefined : v;

export const pemserterPriceSchema = z.object({
  itemNumber: z.string().min(1, "Item Number is required"),
  itemName: z.string().min(1, "Item Name is required"),
  customerSalesPrice: z.preprocess(
    emptyToUndefined,
    z.coerce
      .number({
        required_error: "Customer Sales Price is required",
        invalid_type_error: "Customer Sales Price must be a number",
      })
      .nonnegative("Must be ≥ 0"),
  ),
  discountRate: z.preprocess(
    emptyToUndefined,
    z.coerce
      .number({
        required_error: "Discount Rate is required",
        invalid_type_error: "Discount Rate must be a number",
      })
      .min(0, "Must be ≥ 0")
      .max(1, "Must be a decimal between 0 and 1 (e.g. 0.20 = 20%)"),
  ),
});

export type PemserterPriceFormData = z.infer<typeof pemserterPriceSchema>;
